import styled from 'styled-components';

export const VisitorBookingDetailContainerStyled = styled.div`

`;
